<template>
  <UlDialog
    v-model="dialog"
    :title="title"
    :header-type="showDocument ? 'navigation' : 'information'"
    :left-header-icon="showDocument ? null : 'icons/mail-empty.svg'"
    :show-back-arrow="showDocument"
    @clickBack="showDocument = false"
  >
    <template #text>
      <div v-if="showDocument" class="legal-document">
        <Loading v-if="loadingDocument" />
        <div v-else v-html="documentContent.content" />
      </div>
      <template v-else>
        <div class="mb-8 mb-md-6" v-html="$t('newsletterAgreement.perex')"></div>
        <div class="grey rounded-lg pa-4 text-left">
          <div
            v-for="(content, key) in dialogContent"
            :key="key"
            :class="{
              'mt-6': key > 0
            }"
          >
            <div class="d-flex justify-start align-center">
              <div>
                <v-img
                  contain
                  width="48"
                  height="48"
                  :src="$asset(`img/icons/${content.icon}.svg`)"
                  class="mr-4"
                />
              </div>
              <div v-html="content.text" />
            </div>
          </div>
        </div>
      </template>
    </template>

    <template #actions>
      <v-row v-if="!showDocument" no-gutters class="flex-column pt-4 pb-4 pb-md-10 px-4 px-md-10">
        <div>
          <i18n
            path="newsletterAgreement.footer.text"
            tag="p"
            class="mb-4 text-left text-body-small grey-darken-1--text"
          >
            <template #link>
              <span class="link--inline grey-darken-1--text" @click="showLegalDocument">{{
                $t('newsletterAgreement.footer.linkText')
              }}</span>
            </template>
          </i18n>
        </div>
        <v-row no-gutters>
          <v-col
            :cols="$vuetify.breakpoint.smAndDown ? 12 : 6"
            :class="{
              'pr-1': !$vuetify.breakpoint.smAndDown,
              'pb-2': $vuetify.breakpoint.smAndDown
            }"
          >
            <v-btn block color="tetrary" @click="dialog = false">{{ $t('close') }}</v-btn>
          </v-col>
          <v-col
            :cols="$vuetify.breakpoint.smAndDown ? 12 : 6"
            :class="{
              'pl-1': !$vuetify.breakpoint.smAndDown
            }"
          >
            <SendButton
              :loading="loading"
              block
              :button-text="$t('subscribe')"
              @click="nextButtonAction"
            />
          </v-col>
        </v-row>
      </v-row>
    </template>
  </UlDialog>
</template>

<script>
import breakpoints from '@/mixins/breakpoints';
import checkUserVerification from '@/mixins/checkUserVerification';
import UlDialog from '@/components/Atoms/UlDialog';
import dialogGtm from '@/mixins/dialogGtm';
import Loading from '@/components/Atoms/Loading.vue';
import legalDocuments from '@/mixins/legalDocuments';
import SendButton from '@/components/Forms/Parts/SendButton.vue';

export default {
  name: 'NewsletterAgreementDialog',
  components: {
    SendButton,
    Loading,
    UlDialog
  },
  mixins: [breakpoints, checkUserVerification, dialogGtm, legalDocuments],
  data() {
    return {
      loading: false,
      showDocument: false,
      loadingDocument: false,
      documentContent: {
        content: ''
      }
    };
  },
  computed: {
    title() {
      if (this.loadingDocument) {
        return null;
      }
      return this.showDocument && this.documentContent && this.documentContent.title
        ? this.documentContent.title
        : this.$t('newsletterAgreement.title');
    },
    dialogContent() {
      return this.$t('newsletterAgreement.content');
    },
    dialog: {
      get() {
        return this.$store.state.profile.dashboard.dialog === 'newsletter-agreement';
      },
      set(value) {
        this.$store.commit('profile/dashboard/setDialog', value);
      }
    }
  },
  watch: {
    dialog(newValue) {
      if (newValue) {
        this.dialogChanged('marketing_box', true);
      } else {
        this.dialogChanged('marketing_box', false);
      }
    }
  },
  methods: {
    async showLegalDocument() {
      this.showDocument = true;
      this.loadingDocument = true;
      this.documentContent = await this.getLegalDocument('default', 'newsletter');
      this.loadingDocument = false;
    },

    async nextButtonAction() {
      this.gtmPush({
        event: 'button_click',
        'button.type': this.$t('subscribe'),
        'button.detail': 'marketing_box'
      });

      this.loading = true;

      const newsletter = await this.getLegalDocument('default', 'newsletter');
      await this.$http
        .post('/v3/legal-documents/' + newsletter.id + '/confirm')
        .catch(error => {
          this.$store.dispatch('errorModal/handleError', {
            error,
            showModal: false,
            code: '0x00000022'
          });
        })
        .finally(async () => {
          await this.$auth.fetchUser();
          this.loading = false;
          this.dialog = false;
        });
    }
  }
};
</script>
